import { useAppTranslation } from '@hooks';
import { PresetTag } from '@components/display';
import { TUserActivityState } from '@definitions';

type StatusTagUserPropsType = {
  status: TUserActivityState
};

const StatusTagUser = ({ status }: StatusTagUserPropsType) => {
  const { translate } = useAppTranslation();
  const labels: Record<TUserActivityState, string> = {
    1: translate('managers.active'),
    2: translate('managers.waiting'),
    3: translate('managers.inactive'),
  };
  const isWaiting = status === 2;

  return (
    <PresetTag
      preset={'user-status'}
      state={status}
      withDot={!isWaiting}
      icon={isWaiting ? 'Hourglass03' : undefined}
    >
      {labels[status]}
    </PresetTag>
  );
};

export default StatusTagUser;
